import React from 'react'
import Header from '../../headerone/Main'
import Bredcom from '../../Bredcom/Main'
import Brand from '../../menhomethree/Brand'
import First from '../menplacementglancegallery/First'

function Main() {
  return (
    <>
        <Header/>
        <Bredcom title="Home" subtitle="Placement at a Glance"/>
        <First/>
        {/* <Brand/> */}
    </>
  )
}

export default Main